module.exports = __webpack_public_path__ + "img/icon_back_to_top.9d34301c.svg";